import request from '@/utils/request'
export const queryPage = '/icps/system/sign/basics/basicPricing/QueryPage'
export const batchUpdateOrDelete = ''
export const updateSortNum = ''
export const saveOrUpdate = '/icps/system/sign/basics/basicPricing/saveOrUpdate'
export const Download = '/icps/system/sign/basics/basicPricing/exportList'

export function savePricingSite(data) {
  return request({
    url: '/icps/system/sign/basics/basicPricing/savePricingSite',
    method: 'post',
    data
  })
}
export function getPricingSite(data) {
  return request({
    url: '/icps/system/sign/basics/basicPricing/getPricingSite',
    method: 'post',
    data
  })
}